import { SxProps } from "@mui/material";
import { SelectInput } from "./SelectInput";

export function TheoryExamLanguageInput(props: { source: string; label: string; disabled?: boolean; sx?: SxProps }) {
  const { source, label, disabled, sx } = props;
  return (
    <SelectInput source={source} label={label} options={AUTOVIO_SUPPORTED_LANGUAGES} disabled={disabled} sx={sx} />
  );
}

export const AUTOVIO_SUPPORTED_LANGUAGES: [string, string][] = [
  ["ar", "Arabisch"],
  ["de", "Deutsch"],
  ["el", "Griechisch"],
  ["en", "Englisch"],
  ["es", "Spanisch"],
  ["fr", "Französisch"],
  ["hr", "Kroatisch"],
  ["it", "Italienisch"],
  ["pl", "Polnisch"],
  ["pt", "Portugiesisch"],
  ["ro", "Rumänisch"],
  ["ru", "Russisch"],
  ["tr", "Türkisch"],
];
